"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToggleButton = exports.CustomErrorMessage = void 0;
var react_1 = __importStar(require("react"));
var formik_1 = require("formik");
var Yup = __importStar(require("yup"));
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var HighlightOffSharp_1 = __importDefault(require("@mui/icons-material/HighlightOffSharp"));
var Search_1 = __importDefault(require("@mui/icons-material/Search"));
var Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
var estimation_types_1 = require("@finpay/estimation-types");
var TextField_1 = __importDefault(require("../../text-field/TextField"));
var utils_1 = require("../utils/utils");
var utils_2 = require("../../../utils/utils");
var enums_1 = require("../../../utils/enums");
var tableColumns = [
    { id: 'code', label: 'Code' },
    { id: 'name', label: 'Level of Care' },
    { id: 'rate', label: 'Rate' },
    { id: 'days', label: 'Days/Sessions' },
    { id: 'covered', label: 'Covered' },
    { id: 'daysBeforeCrossover', label: 'Days Before Crossover' },
];
var NewLOCModal = function (_a) {
    var listOfLoc = _a.listOfLoc, _b = _a.initialListOfSelectedLoc, initialListOfSelectedLoc = _b === void 0 ? [] : _b, quoteMethod = _a.quoteMethod, admissionDate = _a.admissionDate, policyEndDate = _a.policyEndDate, vob = _a.vob, vobClassifications = _a.vobClassifications, getFormikValues = _a.getFormikValues;
    var sortedList = (0, utils_1.sortNewFacilityLevelOfCare)(listOfLoc);
    var modifiedSortedList = (0, react_1.useMemo)(function () {
        if (quoteMethod === estimation_types_1.QuoteMethod.RLOS) {
            // set the los days to the value of recommended los days
            return sortedList.map(function (loc) {
                return __assign(__assign({}, loc), { losDays: loc.recommendedLos });
            });
        }
        else {
            // don't modify the list,
            // as it should come in without los days set to recommended los days
            return sortedList;
        }
    }, [quoteMethod, listOfLoc]);
    var originalRows = modifiedSortedList;
    var isInNetwork = Boolean(vob.payer.inNetwork);
    var vobClassificationsFromVob = isInNetwork
        ? vob.inNetwVobClassifications
        : vob.ooNetwVobClassifications;
    var _c = (0, react_1.useState)(modifiedSortedList), rows = _c[0], setRows = _c[1];
    var _d = (0, react_1.useState)(0), page = _d[0], setPage = _d[1];
    var _e = (0, react_1.useState)(5), rowsPerPage = _e[0], setRowsPerPage = _e[1];
    var _f = (0, react_1.useState)(''), searched = _f[0], setSearched = _f[1];
    var _g = (0, react_1.useState)(false), selectedFacGridIsValid = _g[0], setSelectedFacGridIsValid = _g[1];
    var _h = (0, react_1.useState)(0), forceUpdate = _h[0], setForceUpdate = _h[1];
    var filteredColumnsToShow = tableColumns;
    (0, react_1.useEffect)(function () {
        setRows(modifiedSortedList);
    }, [modifiedSortedList]);
    var initialValues = {
        selectedLocs: initialListOfSelectedLoc,
        vobClassificationUpdates: vobClassifications.reduce(function (acc, classification) {
            var locs = initialListOfSelectedLoc.filter(function (loc) {
                return loc.vobClassificationId ===
                    classification.vobClassificationId &&
                    loc.isCovered &&
                    !(vobClassificationsFromVob === null || vobClassificationsFromVob === void 0 ? void 0 : vobClassificationsFromVob.some(function (vobClass) {
                        var _a;
                        return ((_a = vobClass.selectedClassification) === null || _a === void 0 ? void 0 : _a.vobClassificationId) ===
                            loc.vobClassificationId;
                    }));
            });
            if (locs.length > 0) {
                acc[classification.vobClassificationName] = {
                    vobClassification: classification,
                    locs: locs,
                    toggleButtonSelection: 0,
                    coPay: 0,
                    coInsurance: 0,
                    maxDays: 0,
                };
            }
            return acc;
        }, {}),
    };
    var validationSchema = Yup.object().shape({
        selectedLocs: Yup.lazy(function () {
            return Yup.array()
                .of(Yup.object().shape({
                losDays: Yup.number()
                    .integer('Days must be in integer')
                    .required('Days is required')
                    .typeError('Days must be a number')
                    .min(1, 'Days must be 1 or greater')
                    .max(999, 'Days must be less than 1000'),
                pdrRate: Yup.number()
                    .required('Rate is required')
                    .typeError('Rate must be a number')
                    .min(0, 'Rate must be a positive number')
                    .max(99999, 'Rate must be less than 100000'),
                losDaysBeforeCrossover: Yup.number()
                    .typeError('Days Before Crossover must be a number')
                    .integer('Days Before Crossover must be in integer')
                    .min(0, 'Days Before Crossover must be 0 or greater')
                    .max(100, 'Days Before Crossover must be less than 100')
                    .when('$hasCrossover', {
                    is: true,
                    then: Yup.number()
                        .required('Days Before Crossover is required'),
                    otherwise: Yup.number().notRequired()
                })
                    .test('before-crossover', 'Days Before Crossover must be at least 0 days', function (daysBeforeCrossover) {
                    if (hasCrossover) {
                        if (daysBeforeCrossover === undefined || daysBeforeCrossover < 0) {
                            return false;
                        }
                    }
                    return true;
                })
                    .test('before-crossover', 'The total Days Before Crossover must not exceed the available limit', function () {
                    if (hasCrossover) {
                        var daysBetweenPolicyEndAndAdmission = (0, utils_1.getDaysBetweenAdmissionAndPolicyEndDates)({
                            admissionDate: admissionDate,
                            policyEndDate: policyEndDate
                        });
                        var totalDays = formik.values.selectedLocs.reduce(function (acc, loc) {
                            if (typeof loc.losDaysBeforeCrossover === 'number')
                                acc += loc.losDaysBeforeCrossover;
                            return acc;
                        }, 0);
                        return daysBetweenPolicyEndAndAdmission >= totalDays;
                    }
                    else {
                        return true;
                    }
                })
                    .test('before-crossover', 'Days before crossover cannot exceed Days/Sessions', function (daysBeforeCrossover, _a) {
                    var parent = _a.parent;
                    if (hasCrossover) {
                        return (typeof daysBeforeCrossover === 'number' ? daysBeforeCrossover : 0) <= parent.losDays;
                    }
                    else {
                        return true;
                    }
                }),
            }))
                .min(1, 'At least one LOC must be selected');
        }),
        vobClassificationUpdates: Yup.lazy(function (obj) {
            return Yup.object(Object.keys(obj).reduce(function (acc, key) {
                acc[key] = Yup.object().shape({
                    toggleButtonSelection: Yup.number()
                        .required('Required')
                        .oneOf([0, 1, 2], 'Invalid selection'),
                    coPay: Yup.number().when('toggleButtonSelection', {
                        is: function (val) { return val === 0 || val === 2; },
                        then: Yup.number()
                            .required('Co-Pay is required')
                            .typeError('Co-Pay must be a number')
                            .positive('Co-Pay must be positive')
                            .min(0, 'Co-Pay must be 0 or greater'),
                        otherwise: Yup.number().nullable(),
                    }),
                    coInsurance: Yup.number().when('toggleButtonSelection', {
                        is: function (val) { return val === 1 || val === 2; },
                        then: Yup.number()
                            .required('Co-Insurance is required')
                            .positive('Co-Insurance must be positive')
                            .min(0, 'Co-Insurance must be 0 or greater')
                            .max(100, 'Co-Insurance must be 100 or less'),
                        otherwise: Yup.number().nullable(),
                    }),
                    maxDays: Yup.number().when('toggleButtonSelection', {
                        is: function (val) { return val === 0 || val === 2; },
                        then: Yup.number()
                            .integer('Max Days must be an integer')
                            .required('Max Days is required')
                            .min(0, 'Max Days must be 0 or greater')
                            .max(100, 'Max Days must be 100 or less')
                            .nullable(),
                        otherwise: Yup.number().nullable(),
                    }),
                });
                return acc;
            }, {}));
        }),
    });
    var formik = (0, formik_1.useFormik)({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: function () { },
        validateOnChange: true,
        validateOnBlur: true,
        validateOnMount: true,
        validate: function (values) {
            return validationSchema
                .validate(values, { context: { hasCrossover: hasCrossover } })
                .then(function () {
                getFormikValues(formik);
            })
                .catch(function (err) {
                if (err.name === 'ValidationError') {
                    // returns error object for formik
                    var errors = err.inner.reduce(function (errors, error) {
                        var _a;
                        return __assign(__assign({}, errors), (_a = {}, _a[error.path] = error.message, _a));
                    }, {});
                    // set the errors found to formik
                    // then pass it back up
                    formik.setErrors(errors);
                    getFormikValues(formik);
                }
                getFormikValues(formik);
                return {};
            });
        },
    });
    var hasCrossover = (0, react_1.useMemo)(function () {
        var selectedCopy = __spreadArray([], formik.values.selectedLocs, true);
        var _a = (0, utils_1.checkCrossoverAndUpdateLocs)({
            selectedLocs: selectedCopy,
            admissionDate: admissionDate,
            policyEndDate: policyEndDate
        }), isCrossover = _a.isCrossover, newSelectedLocs = _a.newSelectedLocs;
        formik.setFieldValue('selectedLocs', newSelectedLocs).then(function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, formik.validateForm()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        return isCrossover;
    }, [formik.values.selectedLocs.length, forceUpdate, admissionDate.getTime()]);
    (0, react_1.useEffect)(function () {
        getFormikValues(formik);
    }, [formik.values, formik.isValid, formik.dirty]);
    if (quoteMethod !== estimation_types_1.QuoteMethod.SCA)
        filteredColumnsToShow = filteredColumnsToShow.filter(function (col) { return col.id !== 'rate'; });
    if (!hasCrossover) {
        filteredColumnsToShow = filteredColumnsToShow.filter(function (col) { return col.id !== 'daysBeforeCrossover'; });
    }
    var editableDaysBeforeCrossover = function (loc, value) {
        var _a, _b;
        // short curcuit for surcharges (type 1)
        if (loc.locType === 1)
            return react_1.default.createElement(react_1.default.Fragment, null, value);
        var property = loc.facilityLevelOfCareId === 0
            ? 'cfgLevelOfCareId'
            : 'facilityLevelOfCareId';
        var selectedLocIndex = findIndex(formik.values.selectedLocs, property, loc[property]);
        return (react_1.default.createElement(material_1.TextField, __assign({ type: "number" }, formik.getFieldProps("selectedLocs[".concat(selectedLocIndex, "].losDaysBeforeCrossover")), { style: { width: '10rem' }, value: value, onChange: function (e) {
                return changeDaysBeforeCrossover(e.target.value, selectedLocIndex);
            }, error: ((_b = (_a = formik.touched.selectedLocs) === null || _a === void 0 ? void 0 : _a[selectedLocIndex]) === null || _b === void 0 ? void 0 : _b.losDaysBeforeCrossover) &&
                Boolean((0, formik_1.getIn)(formik.errors, "selectedLocs[".concat(selectedLocIndex, "].losDaysBeforeCrossover"))), helperText: react_1.default.createElement(formik_1.ErrorMessage, { name: "selectedLocs[".concat(selectedLocIndex, "].losDaysBeforeCrossover"), component: exports.CustomErrorMessage }) })));
    };
    var changeDaysBeforeCrossover = function (value, selectedLocIndex) { return __awaiter(void 0, void 0, void 0, function () {
        var valueAsNumber, selectedCopy, locCopyReference;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    valueAsNumber = value === '' ? '' : Number(value);
                    selectedCopy = utils_2.Utils.deepClone(formik.values.selectedLocs);
                    locCopyReference = selectedCopy[selectedLocIndex];
                    locCopyReference.losDaysBeforeCrossover = valueAsNumber;
                    locCopyReference.losDaysAfterCrossover =
                        locCopyReference.losDays - valueAsNumber;
                    return [4 /*yield*/, formik.setFieldValue("selectedLocs", selectedCopy)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, formik.validateForm()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var editableRateLos = function (loc, value, rate) {
        var _a, _b, _c, _d, _e, _f;
        var property = loc.facilityLevelOfCareId === 0
            ? 'cfgLevelOfCareId'
            : 'facilityLevelOfCareId';
        var selectedLocIndex = findIndex(formik.values.selectedLocs, property, loc[property]);
        var returnData = react_1.default.createElement(react_1.default.Fragment, null);
        // short curcuit for surcharges (type 1)
        if (loc.locType === 1)
            return react_1.default.createElement(react_1.default.Fragment, null, value);
        switch (quoteMethod) {
            case estimation_types_1.QuoteMethod.AVGLOS:
                returnData = react_1.default.createElement(react_1.default.Fragment, null, value);
                break;
            case estimation_types_1.QuoteMethod.SCA:
                if (rate) {
                    returnData = (react_1.default.createElement(material_1.TextField, __assign({}, formik.getFieldProps("selectedLocs[".concat(selectedLocIndex, "].pdrRate")), { type: "number", style: { width: '10rem' }, onChange: formik.handleChange, error: ((_b = (_a = formik.touched.selectedLocs) === null || _a === void 0 ? void 0 : _a[selectedLocIndex]) === null || _b === void 0 ? void 0 : _b.pdrRate) &&
                            Boolean((0, formik_1.getIn)(formik.errors, "selectedLocs[".concat(selectedLocIndex, "].pdrRate"))), helperText: react_1.default.createElement(formik_1.ErrorMessage, { name: "selectedLocs[".concat(selectedLocIndex, "].pdrRate"), component: exports.CustomErrorMessage }) })));
                }
                else {
                    returnData = (react_1.default.createElement(material_1.TextField, __assign({}, formik.getFieldProps("selectedLocs[".concat(selectedLocIndex, "].losDays")), { style: { width: '10rem' }, type: "number", onChange: function (e) {
                            setForceUpdate(forceUpdate + 1);
                            if (e.target.value && selectedLocIndex >= 0 && hasCrossover) {
                                formik.setFieldValue("selectedLocs[".concat(selectedLocIndex, "]"), __assign(__assign({}, formik.values.selectedLocs[selectedLocIndex]), { losDaysBeforeCrossover: "", losDaysAfterCrossover: "" }));
                                setForceUpdate(forceUpdate + 1);
                            }
                            formik.handleChange(e);
                        }, error: ((_d = (_c = formik.touched.selectedLocs) === null || _c === void 0 ? void 0 : _c[selectedLocIndex]) === null || _d === void 0 ? void 0 : _d.losDays) &&
                            Boolean((0, formik_1.getIn)(formik.errors, "selectedLocs[".concat(selectedLocIndex, "].losDays"))), helperText: react_1.default.createElement(formik_1.ErrorMessage, { name: "selectedLocs[".concat(selectedLocIndex, "].losDays"), component: exports.CustomErrorMessage }) })));
                }
                break;
            case estimation_types_1.QuoteMethod.RLOS:
                returnData = react_1.default.createElement(react_1.default.Fragment, null, value);
                break;
            case estimation_types_1.QuoteMethod.MANUAL:
                if (rate) {
                    returnData = react_1.default.createElement(react_1.default.Fragment, null, value);
                }
                else {
                    returnData = (react_1.default.createElement(material_1.TextField, __assign({}, formik.getFieldProps("selectedLocs[".concat(selectedLocIndex, "].losDays")), { style: { width: '10rem' }, type: "number", onChange: function (e) {
                            setForceUpdate(forceUpdate + 1);
                            if (e.target.value && selectedLocIndex >= 0 && hasCrossover) {
                                formik.setFieldValue("selectedLocs[".concat(selectedLocIndex, "]"), __assign(__assign({}, formik.values.selectedLocs[selectedLocIndex]), { losDaysBeforeCrossover: "", losDaysAfterCrossover: "" }));
                                setForceUpdate(forceUpdate + 1);
                            }
                            formik.handleChange(e);
                        }, error: ((_f = (_e = formik.touched.selectedLocs) === null || _e === void 0 ? void 0 : _e[selectedLocIndex]) === null || _f === void 0 ? void 0 : _f.losDays) &&
                            Boolean((0, formik_1.getIn)(formik.errors, "selectedLocs[".concat(selectedLocIndex, "].losDays"))), helperText: react_1.default.createElement(formik_1.ErrorMessage, { name: "selectedLocs[".concat(selectedLocIndex, "].losDays"), component: exports.CustomErrorMessage }) })));
                }
                break;
            default:
            // nothing
        }
        return returnData;
    };
    var checkIsFormValid2 = (0, react_1.useCallback)(function () {
        var gridIsValid = false;
        gridIsValid = selectedFacGridIsValid;
        // setEnableSaveButtonState(gridIsValid);
    }, [selectedFacGridIsValid]);
    (0, react_1.useEffect)(function () {
        checkIsFormValid2();
    }, [checkIsFormValid2]);
    var requestSearch = function (searchedVal) {
        setSearched(searchedVal);
        var filteredRows = originalRows === null || originalRows === void 0 ? void 0 : originalRows.filter(function (row) {
            var _a;
            return ((row === null || row === void 0 ? void 0 : row.facilityLevelOfCareName.toLowerCase().includes(searchedVal.toLowerCase())) ||
                ((_a = row === null || row === void 0 ? void 0 : row.facilityLevelOfCareCode) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().includes(searchedVal.toLowerCase())));
        });
        setRows(filteredRows);
        setPage(0);
    };
    var cancelSearch = function () {
        setSearched('');
        requestSearch(searched);
    };
    var clearSelectedLocs = function () {
        formik === null || formik === void 0 ? void 0 : formik.setValues({
            selectedLocs: [],
            vobClassificationUpdates: {}
        }, true);
    };
    var handleChangePage = function (event, newPage) {
        setPage(newPage);
    };
    var handleChangeRowsPerPage = function (event) {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    var isSelected = function (id, property) {
        return findIndex(formik.values.selectedLocs, property, id) !== -1;
    };
    // this hanlder is for when the checkbox is clicked
    // it updates the selectedLocs array
    // and updates the vobClassificationUpdates array
    // and validates the form
    var handleCheckboxClick = function (row) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedCopy, property, index, isRemovingLoc, newSelectedLocs, newListOfLocsByVobClassificationThatAreNotInVob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selectedCopy = __spreadArray([], formik.values.selectedLocs, true);
                    property = row.facilityLevelOfCareId === 0
                        ? 'cfgLevelOfCareId'
                        : 'facilityLevelOfCareId';
                    index = findIndex(selectedCopy, property, row[property]);
                    isRemovingLoc = index > -1;
                    if (isRemovingLoc) {
                        selectedCopy.splice(index, 1);
                    }
                    else {
                        selectedCopy.push(row);
                    }
                    newSelectedLocs = (0, utils_1.checkCrossoverAndUpdateLocs)({
                        selectedLocs: selectedCopy,
                        admissionDate: admissionDate,
                        policyEndDate: policyEndDate
                    }).newSelectedLocs;
                    newListOfLocsByVobClassificationThatAreNotInVob = vobClassifications.reduce(function (acc, classification) {
                        var existingVobClassification = formik.values.vobClassificationUpdates[classification.vobClassificationName];
                        var locs = newSelectedLocs.filter(function (loc) {
                            return (loc.vobClassificationId ===
                                classification.vobClassificationId && loc.isCovered &&
                                !(vobClassificationsFromVob === null || vobClassificationsFromVob === void 0 ? void 0 : vobClassificationsFromVob.some(function (vobClass) {
                                    var _a;
                                    return ((_a = vobClass.selectedClassification) === null || _a === void 0 ? void 0 : _a.vobClassificationId) ===
                                        loc.vobClassificationId;
                                })));
                        });
                        if (locs.length > 0) {
                            acc[classification.vobClassificationName] =
                                existingVobClassification
                                    ? __assign(__assign({}, existingVobClassification), { locs: locs }) : {
                                    vobClassification: classification,
                                    locs: locs,
                                    toggleButtonSelection: 0,
                                    coPay: null,
                                    coInsurance: null,
                                    maxDays: null,
                                };
                        }
                        else if (existingVobClassification) {
                            delete acc[classification.vobClassificationName];
                        }
                        return acc;
                    }, {});
                    return [4 /*yield*/, formik.setFieldValue('vobClassificationUpdates', newListOfLocsByVobClassificationThatAreNotInVob)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, formik.setFieldValue('selectedLocs', newSelectedLocs)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, formik.validateForm({
                            selectedLocs: newSelectedLocs,
                            vobClassificationUpdates: newListOfLocsByVobClassificationThatAreNotInVob,
                        })];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getTableBodyRow = function (row, selectedRow, isItemSelected, filteredColumnsToShow) {
        var property = row.facilityLevelOfCareId === 0
            ? 'cfgLevelOfCareId'
            : 'facilityLevelOfCareId';
        var tableCells = filteredColumnsToShow.map(function (column) {
            var _a;
            switch (column.id) {
                case 'code':
                    return (react_1.default.createElement(material_1.TableCell, null, row === null || row === void 0 ? void 0 : row.facilityLevelOfCareCode));
                case 'name':
                    return (react_1.default.createElement(material_1.TableCell, null, row === null || row === void 0 ? void 0 : row.facilityLevelOfCareName));
                case 'rate':
                    return (react_1.default.createElement(material_1.TableCell, null, isItemSelected ? (editableRateLos(selectedRow, row.locType === 1
                        ? '-'
                        : selectedRow.pdrRate, true)) : (react_1.default.createElement(react_1.default.Fragment, null, row.locType === 1
                        ? '-'
                        : quoteMethod === estimation_types_1.QuoteMethod.SCA ||
                            quoteMethod === estimation_types_1.QuoteMethod.MANUAL
                            ? ''
                            : row.pdrRate))));
                case 'days':
                    return (react_1.default.createElement(material_1.TableCell, null, isItemSelected ? (editableRateLos(selectedRow, row.locType === 1
                        ? '-'
                        : quoteMethod === estimation_types_1.QuoteMethod.RLOS
                            ? row.recommendedLos
                            : selectedRow.losDays, false)) : (react_1.default.createElement(react_1.default.Fragment, null, row.locType === 1
                        ? '-'
                        : quoteMethod === estimation_types_1.QuoteMethod.SCA ||
                            quoteMethod === estimation_types_1.QuoteMethod.MANUAL
                            ? ''
                            : quoteMethod === estimation_types_1.QuoteMethod.RLOS
                                ? row.recommendedLos
                                : row.losDays))));
                case 'covered':
                    return (react_1.default.createElement(material_1.TableCell, null, isItemSelected ? (((_a = selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.facilityPayorLocRateLos) === null || _a === void 0 ? void 0 : _a.isCovered) || selectedRow.isCovered ? (react_1.default.createElement(react_1.default.Fragment, null, "Yes")) : (react_1.default.createElement(react_1.default.Fragment, null, "No"))) : (row === null || row === void 0 ? void 0 : row.isCovered) ? (react_1.default.createElement(react_1.default.Fragment, null, "Yes")) : (react_1.default.createElement(react_1.default.Fragment, null, "No"))));
                case 'daysBeforeCrossover':
                    return (react_1.default.createElement(material_1.TableCell, null, isItemSelected &&
                        editableDaysBeforeCrossover(selectedRow, row.locType === 1 ? '-' :
                            selectedRow.losDaysBeforeCrossover)));
                default:
                    return undefined;
            }
        });
        return (react_1.default.createElement(material_1.TableRow, { key: row[property] },
            react_1.default.createElement(material_1.TableCell, null,
                react_1.default.createElement(Checkbox_1.default, { onClick: function () { return handleCheckboxClick(row); }, className: "selectCheckbox", checked: isItemSelected })),
            tableCells));
    };
    var findIndex = function (list, property, id) {
        return list.findIndex(function (item) {
            return item[property] === id;
        });
    };
    var tableBodyRows = rows === null || rows === void 0 ? void 0 : rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row) {
        var property = row.facilityLevelOfCareId === 0
            ? 'cfgLevelOfCareId'
            : 'facilityLevelOfCareId';
        var isItemSelected = isSelected(row[property], property);
        var itemIndex = findIndex(formik.values.selectedLocs, property, row[property]);
        var selectedRow = formik.values.selectedLocs[itemIndex];
        return getTableBodyRow(row, selectedRow, isItemSelected, filteredColumnsToShow);
    });
    return (react_1.default.createElement(formik_1.FormikProvider, { value: formik },
        react_1.default.createElement(material_1.Grid, { item: true, xs: 5, className: "pb-2", direction: "column", style: { marginTop: '1rem' } },
            react_1.default.createElement(TextField_1.default, { placeholder: "Search by code or name", name: "searched", value: searched, onChange: function (event) { var _a; return requestSearch((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value); }, onBlur: function () { return cancelSearch(); }, startAdornment: react_1.default.createElement(Search_1.default, null) })),
        react_1.default.createElement(material_1.TableContainer, { component: material_1.Paper },
            react_1.default.createElement(material_1.Table, { size: "small" },
                react_1.default.createElement(material_1.TableHead, null,
                    react_1.default.createElement(material_1.TableRow, null,
                        react_1.default.createElement(material_1.TableCell, null),
                        filteredColumnsToShow.map(function (col) {
                            return (react_1.default.createElement(material_1.TableCell, { key: col.id }, col.label));
                        }))),
                react_1.default.createElement(material_1.TableBody, null, tableBodyRows)),
            react_1.default.createElement(material_1.Grid, { container: true, justifyContent: "space-between" },
                react_1.default.createElement(material_1.Grid, { item: true },
                    react_1.default.createElement(material_1.IconButton, { title: "clear selected", style: {
                            fontSize: '1.5rem',
                            marginLeft: '1.25rem',
                        }, onClick: function () { return clearSelectedLocs(); }, size: "large" },
                        react_1.default.createElement(HighlightOffSharp_1.default, { color: "error" }),
                        " Clear selected")),
                react_1.default.createElement(material_1.Grid, { item: true },
                    react_1.default.createElement(material_1.TablePagination, { component: "div", rowsPerPageOptions: [
                            5,
                            10,
                            50,
                            {
                                value: rows.length,
                                label: 'All',
                            },
                        ], count: rows.length, rowsPerPage: rowsPerPage, page: page, labelRowsPerPage: 'View', onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage })))),
        Object.keys(formik.values.vobClassificationUpdates).length > 0 && (react_1.default.createElement(material_1.Box, { style: { marginTop: '3rem' } },
            react_1.default.createElement(material_1.Typography, { variant: "h6" }, "VOB Classification Updates"),
            Object.keys(formik.values.vobClassificationUpdates).map(function (key) {
                return (react_1.default.createElement(VobClassificationUpdate, { key: key, classificationName: key, formik: formik }));
            })))));
};
// formik error message can be a string or a react component
var CustomErrorMessage = function (props) { return (react_1.default.createElement("div", { style: { fontSize: '.8rem', color: 'red', margin: 0 } }, typeof props.children === 'function'
    ? props.children('')
    : props.children)); };
exports.CustomErrorMessage = CustomErrorMessage;
exports.StyledToggleButton = (0, styles_1.styled)(material_1.ToggleButton)(function (_a) {
    var selectedColor = _a.selectedColor;
    return ({
        '&.MuiToggleButton-root': {
            fontWeight: 'bold',
        },
        '&.Mui-selected, &.Mui-selected:hover': {
            color: 'white',
            backgroundColor: selectedColor,
        },
    });
});
var VobClassificationUpdate = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var classificationName = _a.classificationName, formik = _a.formik;
    var values = formik.values, errors = formik.errors, touched = formik.touched;
    var _p = values.vobClassificationUpdates[classificationName], toggleButtonSelection = _p.toggleButtonSelection, locs = _p.locs;
    var updateVobClassification = function (fieldName, value) { return __awaiter(void 0, void 0, void 0, function () {
        var resetForm, formValues;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    resetForm = fieldName === 'toggleButtonSelection';
                    formValues = {};
                    if (resetForm) {
                        formValues = __assign(__assign({}, values.vobClassificationUpdates[classificationName]), { toggleButtonSelection: value, coPay: '', coInsurance: '', maxDays: '' });
                    }
                    else {
                        formValues = __assign(__assign({}, values.vobClassificationUpdates[classificationName]), (_a = {}, _a[fieldName] = value, _a));
                    }
                    return [4 /*yield*/, formik.setFieldValue("vobClassificationUpdates.".concat(classificationName), formValues, true)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var isCopayEnabled = toggleButtonSelection === 0 || toggleButtonSelection === 2;
    var isCoInsuranceEnabled = toggleButtonSelection === 1 || toggleButtonSelection === 2;
    var isBothEnabled = toggleButtonSelection === 2 || toggleButtonSelection === 0;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Box, null,
            react_1.default.createElement(material_1.Box, { display: "flex", justifyContent: "space-between", flex: '1 1 0px' },
                react_1.default.createElement(material_1.Typography, { variant: "subtitle1", width: '33%' }, classificationName),
                react_1.default.createElement(material_1.ToggleButtonGroup, __assign({}, formik.getFieldProps("vobClassificationUpdates.".concat(classificationName, ".toggleButtonSelection")), { value: toggleButtonSelection, exclusive: true, onChange: function (event, newValue) {
                        if (newValue !== null) {
                            formik.setFieldValue("vobClassificationUpdates.".concat(classificationName, ".toggleButtonSelection"), newValue);
                        }
                    }, "aria-label": "text alignment" }),
                    react_1.default.createElement(exports.StyledToggleButton, { selectedColor: enums_1.StatusColors.blue, value: 0, "aria-label": "check", onClick: function (e) {
                            updateVobClassification('toggleButtonSelection', Number(e.target.value));
                        } }, "Co-Pay"),
                    react_1.default.createElement(exports.StyledToggleButton, { selectedColor: enums_1.StatusColors.blue, value: 1, "aria-label": "check", onClick: function (e) {
                            updateVobClassification('toggleButtonSelection', Number(e.target.value));
                        } }, "Co-Insurance"),
                    react_1.default.createElement(exports.StyledToggleButton, { selectedColor: enums_1.StatusColors.blue, value: 2, "aria-label": "check", onClick: function (e) {
                            updateVobClassification('toggleButtonSelection', Number(e.target.value));
                        } }, "Both")),
                react_1.default.createElement(material_1.TextField, __assign({}, formik.getFieldProps("vobClassificationUpdates.".concat(classificationName, ".coPay")), { style: { width: '10%' }, label: "Co-Pay", type: "number", value: formik.values.vobClassificationUpdates[classificationName].coPay, onChange: function (e) {
                        var value = e.target.value === ''
                            ? ''
                            : Number(e.target.value);
                        updateVobClassification('coPay', value);
                    }, error: ((_c = (_b = touched.vobClassificationUpdates) === null || _b === void 0 ? void 0 : _b[classificationName]) === null || _c === void 0 ? void 0 : _c.coPay) &&
                        Boolean((_e = (_d = errors.vobClassificationUpdates) === null || _d === void 0 ? void 0 : _d[classificationName]) === null || _e === void 0 ? void 0 : _e.coPay), helperText: react_1.default.createElement(formik_1.ErrorMessage, { name: "vobClassificationUpdates.".concat(classificationName, ".coPay"), component: exports.CustomErrorMessage }), disabled: !isCopayEnabled })),
                react_1.default.createElement(material_1.TextField, __assign({}, formik.getFieldProps("vobClassificationUpdates.".concat(classificationName, ".coInsurance")), { style: { width: '10%' }, type: "number", value: formik.values.vobClassificationUpdates[classificationName].coInsurance, label: "Co-Insurance %", onChange: function (e) {
                        var value = e.target.value === ''
                            ? ''
                            : Number(e.target.value);
                        updateVobClassification('coInsurance', value);
                    }, error: ((_g = (_f = touched.vobClassificationUpdates) === null || _f === void 0 ? void 0 : _f[classificationName]) === null || _g === void 0 ? void 0 : _g.coInsurance) &&
                        Boolean((_j = (_h = errors.vobClassificationUpdates) === null || _h === void 0 ? void 0 : _h[classificationName]) === null || _j === void 0 ? void 0 : _j.coInsurance), helperText: react_1.default.createElement(formik_1.ErrorMessage, { name: "vobClassificationUpdates.".concat(classificationName, ".coInsurance"), component: exports.CustomErrorMessage }), disabled: !isCoInsuranceEnabled })),
                react_1.default.createElement(material_1.TextField, __assign({}, formik.getFieldProps("vobClassificationUpdates.".concat(classificationName, ".maxDays")), { style: { width: '10%' }, label: "Max Days", type: "number", value: formik.values.vobClassificationUpdates[classificationName].maxDays, onChange: function (e) {
                        var value = e.target.value === ''
                            ? ''
                            : Number(e.target.value);
                        updateVobClassification('maxDays', value);
                    }, error: ((_l = (_k = touched.vobClassificationUpdates) === null || _k === void 0 ? void 0 : _k[classificationName]) === null || _l === void 0 ? void 0 : _l.maxDays) &&
                        Boolean((_o = (_m = errors.vobClassificationUpdates) === null || _m === void 0 ? void 0 : _m[classificationName]) === null || _o === void 0 ? void 0 : _o.maxDays), helperText: react_1.default.createElement(formik_1.ErrorMessage, { name: "vobClassificationUpdates.".concat(classificationName, ".maxDays"), component: exports.CustomErrorMessage }), disabled: !isBothEnabled }))),
            react_1.default.createElement(material_1.Box, null, locs.map(function (loc) {
                return (react_1.default.createElement(material_1.Typography, { variant: "subtitle2" }, loc.facilityLevelOfCareName));
            })))));
};
exports.default = NewLOCModal;
